import React from 'react';
import { connect } from 'react-redux';
import { setErrorStatus } from '../../redux/user';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({ hasError: nextProps.hasError });
	}

	onCloseModal() {
		this.props.setErrorStatus(false);
		window.location.reload(false);
	}

	render() {
		return <div style={{ height: '100%' }}>{this.props.children}</div>;
	}
}

const mapStateToProps = (state) => ({
	hasError: state.user.is_error_occured
});

const mapDispatchToProps = (dispatch) => ({
	setErrorStatus: (value) => dispatch(setErrorStatus(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
